const campaignRegionNomination = {
	title: 'Přehled nominací v regionech',
};

const table = {
	tableNominationsHeader: 'Nominace',
	tableAgencyHeader: 'Oblast',
};

export default {
	...campaignRegionNomination,
	...table,
};
